<template>
 	<div class="page-wrapper">
    <header class="header arrow-down" role="banner">
      <div class="logo">
        SE - MaLau
      </div>
    </header>

    <nav id="nav" class="nav arrow-down">
      <ul id="navMain" class="main-nav">
        <li v-for="item in nav_items" :key="item.idx">
          <template v-if="activeIndex===item.idx">
            <b class="main-nav__item-act">{{item.message}}</b>
          </template>
          <template v-else>
            <a href="#" @click="switchToNextSite(item.idx)">{{ item.message}}</a>
          </template>
        </li>
      </ul>
    </nav>

    <slot></slot>

    <footer class="footer" role="contentinfo">
      <p class="copy">
        Responsive Webdesign - erschienen im
        <a
          href="https://www.rheinwerk-verlag.de/responsive-webdesign_4395/"
          target="_blank"
          title="Öffnet www.rheinwerk-verlag.de in einem neuen Fenster"
        >Rheinwerk Verlag</a> &copy;&nbsp;2013&nbsp;-&nbsp;2017
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "MyHeaderVue",
  props: ['nav_items', 'init_index'],
  data() {
    return {
      activeIndex: this.init_index
    };
  },
  methods: {
    switchToNextSite: function(index) {
      this.activeIndex = index;
      this.$emit('site-index', index)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "https://fonts.googleapis.com/css?family=Raleway:500|Roboto:300";
@import "../../assets/css/normalize.css";
@import "../../assets/css/atmosphere.css";
@import "../../assets/css/layout.css";
/*
@import "../../assets/basis.css"; 
@import "../../assets/layout-fix.css"; 
*/
</style>



// WEBPACK FOOTER //
// src/components/global/global-layout.vue